import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
var CheckboxDialogComponent = /** @class */ (function () {
    function CheckboxDialogComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.title = data.TitleText || 'Input Requested';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';
        this.checkboxlabel = data.CheckboxLabel || '';
        this.checkboxoption = (data.CheckboxOption != null ? data.CheckboxOption : false);
    }
    CheckboxDialogComponent.prototype.ngOnInit = function () {
    };
    CheckboxDialogComponent.prototype.CancelHandler = function () {
        this.dialogRef.close(null);
    };
    CheckboxDialogComponent.prototype.OKHandler = function () {
        this.dialogRef.close(this.checkboxoption);
    };
    return CheckboxDialogComponent;
}());
export { CheckboxDialogComponent };
// #region Custom Classes
var BaseCheckboxDialogOptions = /** @class */ (function () {
    function BaseCheckboxDialogOptions() {
    }
    return BaseCheckboxDialogOptions;
}());
export { BaseCheckboxDialogOptions };
// #endregion
